"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appStylesBaseDefault = void 0;
var primaryColors = {
    lighter: '#cfc4ed',
    light: '#ac95ef',
    medium: '#1a73e8',
    dark: '#5431bd',
    darker: '#3d2389',
};
exports.appStylesBaseDefault = {
    animationSeconds: {
        shorter: 0.1,
        short: 0.15,
        medium: 0.2,
        long: 0.25,
        longer: 0.3,
    },
    textColor: {
        primary: {
            lightest: '#fff',
            lighter: '#ddd',
            light: '#677578',
            medium: 'rgb(29, 28, 29)',
            dark: '#444',
            darker: '#000',
            darkest: '#000',
        },
        brand: {
            lightest: primaryColors.lightest,
            lighter: primaryColors.lighter,
            light: primaryColors.light,
            medium: primaryColors.medium,
            dark: primaryColors.dark,
            darker: primaryColors.darker,
            darkest: primaryColors.darkest,
        },
        success: {
            lighter: '#51b474',
            light: '#51b474',
            medium: '#51b474',
            dark: '#408f5c',
            darker: '#408f5c',
        },
        danger: {
            lighter: '#d73a49',
            light: '#d73a49',
            medium: '#d73a49',
            dark: '#a02b36',
            darker: '#a02b36',
        },
        warning: {
            lighter: '#f8c83e',
            light: '#fcc529',
            medium: '#ffc317',
            dark: '#dea913',
            darker: '#c49203',
        },
    },
    placeholderTextColor: {
        lighter: '#ccc',
        light: '#bbb',
        medium: '#aaa',
        dark: '#999',
        darker: '#888',
    },
    linkColor: {
        lighter: primaryColors.medium,
        light: primaryColors.dark,
        medium: primaryColors.darker,
        dark: primaryColors.darker,
        darker: primaryColors.darker,
    },
    linkVisitedColor: {
        lighter: '#609',
        light: '#609',
        medium: '#609',
        dark: '#609',
        darker: '#609',
    },
    backgroundColor: {
        primary: primaryColors,
        neutral: {
            lightest: '#fff',
            lighter: '#F2F3F5',
            light: '#eee',
            medium: '#ddd',
            dark: '#ccc',
            darker: '#888',
            darkest: '#222',
        },
        warning: {
            lighter: '#f8c83e',
            light: '#fcc529',
            medium: '#ffc317',
            dark: '#dea913',
            darker: '#c49203',
        },
        success: {
            lighter: '#51b474',
            light: '#51b474',
            medium: '#51b474',
            dark: '#408f5c',
            darker: '#408f5c',
        },
        danger: {
            lighter: '#d73a49',
            light: '#d73a49',
            medium: '#d73a49',
            dark: '#a02b36',
            darker: '#a02b36',
        },
    },
    borderColor: {
        lighter: '#eee',
        light: '#d7d7d7',
        medium: '#dfe1e5',
        dark: '#a2a2a4',
        darker: '#9c9da0',
    },
    lineHeight: {
        smaller: '1em',
        small: '1.20em',
        medium: '1.40em',
        big: '1.70em',
        bigger: '2em',
    },
    fontWeight: {
        smaller: '100',
        small: '400',
        medium: '500',
        big: '600',
        bigger: '800',
    },
    fontFamily: {
        primary: "'Open Sans', Helvetica, Arial, sans-serif",
        secondary: "'Open Sans', Helvetica, Arial, sans-serif",
    },
    widthBreakpoints: {
        medium: 512,
        big: 1024,
    },
    borderRadius: {
        smaller: '4px',
        small: '8px',
        medium: '12px',
        big: '16px',
        bigger: '20px',
    },
    bigLayoutWidth: '1024px' /* deprecated use widthBreakpoints */,
    spacing: {
        smaller: '4px',
        small: '8px',
        medium: '16px',
        big: '32px',
        bigger: '64px',
    },
    iconSizes: {
        smallest: '10px',
        smaller: '16px',
        small: '20px',
        medium: '24px',
        big: '30px',
        bigger: '34px',
        biggest: '42px',
    },
    fontSizes: {
        smallest: '.6rem',
        smaller: '.8rem',
        small: '.9rem',
        medium: '1rem',
        big: '1.2rem',
        bigger: '1.4rem',
        biggest: '1.6rem',
    },
    zIndex: {
        basement: -1,
        ground: 0,
        levelOne: 1,
        levelTwo: 2,
        levelThree: 3,
        levelFour: 4,
        levelFive: 5,
    },
    // Legacy
    PRIMARY_COLOR: '#7950f2',
    PRIMARY_COLOR_DARK: '#5431bd',
    BORDER_RADIUS: '4px',
    NEUTRAL_HIGH_LIGHT_COLOR: '#eee',
    NEUTRAL_HIGH_LIGHT_COLOR_DARK: '#444',
    WARNING_HIGHLIGHT_COLOR: 'rgba(249, 221, 137, 1)',
    WARNING_HIGHLIGHT_COLOR_DARK: 'rgba(245, 211, 109, 1)',
    NEUTRAL_BORDER_COLOR_LIGHT: '#d7d7d7',
    NEUTRAL_BORDER_COLOR: '#dfe1e5',
    NEUTRAL_BORDER_DARK: '#a2a2a4',
    NEUTRAL_BORDER_DARKER: '#9c9da0',
    PLACEHOLDER_COLOR: '#ccc',
    WARNING_COLOR: '#d2b502',
    WARNING_COLOR_DARK: '#af9700',
    DANGER_COLOR: '#d73a49',
    DANGER_COLOR_DARK: '#a02b36',
    TEXT_COLOR: 'rgb(29, 28, 29)',
    LINK_COLOR: '#1D4495',
    LINK_COLOR_DARK: '#0D1423',
    LINK_HIGHLIGHT_COLOR: 'rgba(var(--sk_highlight_accent,29,155,209),.1)',
    LINK_VISITED_COLOR: '#609',
    TEXT_COLOR_LIGHT: 'rgb(97, 96, 97)',
    SUCCESS_COLOR: '#51b474',
    SUCCESS_COLOR_DARK: '#408f5c',
    PRIMARY_BACKGROUND_COLOR: '#F2F3F5',
    BIG_LAYOUT_WIDTH: '1024px',
    FONT_WEIGHT_NORMAL: '400',
    FONT_WEIGHT_BOLD: '600',
    FONT_WEIGHT_BOLDER: '800',
};
